// L'appel final : le ciel du soir (public/media/evening-sky.jpg), l'horloge 02:47 en très grand,
// et la phrase qui ferme la boucle ouverte par le hero.
import { Link } from 'react-router-dom'
import { PhoneMock } from './ProductMock'
import { useT } from '../../lib/i18n'

const PUB = process.env.PUBLIC_URL || ''
const SKY = { '--sky-end': `url(${PUB}/media/evening-sky.jpg)`, '--sky-end-m': `url(${PUB}/media/evening-sky-m.jpg)` }

export default function EndCta () {
  const e = useT().endCta
  return (
    <section className="lp-end" style={SKY}>
      <div className="lp-night__stars" aria-hidden="true" />
      <div className="lp-wrap lp-end__in">
        <div className="lp-end__txt lp-rv">
          <span className="lp-end__clock" aria-hidden="true">{e.clock.slice(0, 2)}<em>:</em>{e.clock.slice(3)}</span>
          <h2 className="lp-h2 lp-h2--night lp-end__h">{e.title}</h2>
          <p className="lp-lead lp-lead--night">{e.lead}</p>
          <Link to="/register" className="lp-btn lp-btn--white lp-btn--lg">{e.cta}</Link>
          <span className="lp-end__hint">{e.hint}</span>
        </div>
        <div className="lp-end__art lp-rv" aria-hidden="true">
          <span className="lp-end__glow" />
          <PhoneMock />
        </div>
      </div>
    </section>
  )
}
